/*
 *
 * Communication Preferences actions
 *
 */
import {
  DEFAULT_ACTION,
  GET_PREFERENCES,
  POST_PREFERENCES,
  UPDATE_PREFERENCES,
  UPDATE_GROUP_PREFERENCES,
  UPDATE_SHOW_RECEPIENT_ADDED_SUCCESS_MODAL,
} from './constants';
import { ICommPreferences } from './types';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function fetchPreferencesAction(data: ICommPreferences) {
  return {
    type: GET_PREFERENCES,
    data,
  };
}

export function addPreferencesAction(data: ICommPreferences) {
  return {
    type: POST_PREFERENCES,
    data,
  };
}

export function updatePreferencesAction(data: ICommPreferences) {
  return {
    type: UPDATE_PREFERENCES,
    data,
  };
}

export function updateGroupPreferencesAction(data: ICommPreferences) {
  return {
    type: UPDATE_GROUP_PREFERENCES,
    data,
  };
}

export const updateShowRecepientAddedSuccessModal = (
  data: ICommPreferences,
) => ({ type: UPDATE_SHOW_RECEPIENT_ADDED_SUCCESS_MODAL, data });
